module.exports = __webpack_public_path__ + "static/img/00077D_3_R_20200414_LC.912a5ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/00077D_3_R_20200414_LC.png
// module id = m+6P
// module chunks = 0